import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=98cd6896"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavigationAccountSwitcher: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/navigation/AccountSwitcher.vue').default,NavigationNavContractedSection: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/navigation/NavContractedSection.vue').default,NavigationNavExpandedSection: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/navigation/NavExpandedSection.vue').default})
